module.exports = __webpack_public_path__ + "img/chiku08.01fa6604.png";